// libraries
import styled from 'styled-components';

export const StyledTodayManpowerCard = styled.div`
  padding: 14px 20px;
  min-width: 300px;
  width: 300px;
  height: 176px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(
      115.38deg,
      #0dffae -15.48%,
      rgba(13, 255, 174, 0.34) 9.57%,
      rgba(13, 255, 174, 0) 58.82%,
      rgba(13, 255, 174, 0.49) 110.66%,
      #0dffae 146.08%
    );

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 10;
  }

  > h2 {
    margin-bottom: 7px;
    color: var(--color-white) !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
`;

export const StyledChartBox = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  margin-top: 6px;

  > canvas {
    position: relative;
    height: 100px !important;
  }
`;

export const StyledTotalLegend = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: var(--color-white);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &.total {
      color: #969696;
      font-size: 10px;
    }

    > span {
      color: var(--color-white);
    }
  }
`;

export const StyledTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTableHeader = styled.div`
  display: grid;
  /* grid-template-columns: 68px 113px 52px 26px; */
  grid-template-columns: 113px 68px 52px 26px;
  padding-bottom: 5px;
  border-bottom: 1px solid #696969;
  margin-bottom: 8px;

  > p {
    text-align: center;
    color: #696969;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    &:first-of-type {
      text-align: left;
    }
  }
`;

export const StyledTableRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  max-height: 80px;
  overflow-y: auto;
`;

interface StyledTableRowProps {
  $bgColor: string;
}

export const StyledTableRow = styled.div<StyledTableRowProps>`
  display: grid;
  align-items: center;
  /* grid-template-columns: 68px 113px 52px 26px; */
  grid-template-columns: 113px 68px 52px 26px;

  .title {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: relative;
    padding-left: 9px;
    color: var(--color-white);

    &::before {
      content: '';
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 12px;
      border-radius: 8px;
      background-color: ${(props) => props.$bgColor};
    }
  }

  .progress {
    position: relative;
    width: 100%;
    height: 12px;
    border-radius: 6px;
    background-color: transparent;
    overflow: hidden;
  }

  .number {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: var(--color-white) !important;

    > span {
      color: var(--color-white) !important;
    }
  }
`;

interface ProgressBarProps {
  $width: number;
  $backWidth: number;
  $bgColor: string;
  $subColor: string;
}

export const ProgressBar = styled.div<ProgressBarProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0 6px 6px 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
    background-color: ${(props) => props.$bgColor};
    width: ${(props) =>
      props.$backWidth ? Math.min(Math.max((props.$width / props.$backWidth) * 100, 0), 100) : 0}%;
    height: 100%;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
    background-color: ${(props) => props.$subColor};
    opacity: 0.5;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`;
